module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"product_category":"Product Category"}}')
  delete Component.options._Ctor
}
